import { reloadMobileHandler, renderComponent } from '@/utils/tools';
import initSliderBlog from './slider';
import PostsLoader from './loader';

interface BlogConfig {
  lang: string;
  posts: string[];
  tag?: string | null;
}

export default ({
  lang,
  posts,
  tag
}: BlogConfig): void => {
  // FIXME:
  (window as Window & {
    initSliderBlog?: typeof initSliderBlog
  }).initSliderBlog = initSliderBlog;

  posts.forEach((post) => initSliderBlog(`#swiper-blog-${post}`));

  renderComponent(PostsLoader, { lang, tag });

  // reload on screen resize
  reloadMobileHandler();
};
